export default __webpack_public_path__ + "static/media/BrowNews_x600.dca75e25.png";